import { Text } from '@mnd-frontend/ui/publish/components';
import { useReportTranslation } from '../../hooks';
import { getDefaultSectionDescription } from '../../utils';

type Variant = 'reportLabelMedium';
type AsElement = 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5';

export const SectionDescription = ({
  as,
  variant,
  section,
}: {
  as: AsElement;
  variant: Variant;
  textAlign?: 'left' | 'center' | 'right';
  section: { __typename: string; id: string; description?: string | null };
}) => {
  const { t } = useReportTranslation();
  const description = getDefaultSectionDescription({ section, t });

  return (
    <Text as={as} variant={variant} color="GREY_700">
      {description}
    </Text>
  );
};
